import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {AuthTokenResponse} from '../../models/auth-token-response.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private token: string = '';

  constructor(private readonly http: HttpClient) {
  }

  fetchAuthToken(): Observable<AuthTokenResponse> {
    const headers = { 'X-App-Name': 'JPP-FE' };
    return this.http.get<AuthTokenResponse>('api/auth/token', { headers });
  }

  setToken(response: AuthTokenResponse): void {
    this.token = response.token;
    localStorage.setItem('authToken', response.token);
    localStorage.setItem('authData', JSON.stringify(response));
  }

  getToken(): string {
    return this.token || localStorage.getItem('authToken') || '';
  }

  waitForToken(maxWaitMs = 3000, checkIntervalMs = 100): Promise<void> {
    return new Promise((resolve, reject) => {
      const start = Date.now();

      const interval = setInterval(() => {
        const token = localStorage.getItem('authToken');
        if (token) {
          clearInterval(interval);
          resolve();
        } else if (Date.now() - start >= maxWaitMs) {
          clearInterval(interval);
          reject(new Error('Auth token not found in time'));
        }
      }, checkIntervalMs);
    });
  }


}
